import { render } from "./vappletadvertedit.vue?vue&type=template&id=a45c717c&scoped=true"
import script from "./vappletadvertedit.vue?vue&type=script&lang=js"
export * from "./vappletadvertedit.vue?vue&type=script&lang=js"

import "./vappletadvertedit.vue?vue&type=style&index=0&id=a45c717c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a45c717c"]])

export default __exports__